import { OfferMappingBody, OfferMappingResponse } from '../../../../API';
import { DataManagerState, DataManagerStateFullReturnType } from '../../../DataManager';

export type OfferMappingsStateFullReturnType = DataManagerStateFullReturnType<OfferMappingResponse, OfferMappingBody>;

export function OfferMappingsState(name: string): OfferMappingsStateFullReturnType {
  return DataManagerState<OfferMappingResponse, OfferMappingBody>(name);
}
